<template>
  <!-- 中奖弹窗，注意父容器设置为整个游戏详情页，使其始终居中显示 -->
  <section>
    <van-popup
      v-model="showPopup"
      position="center"
      :close-on-click-overlay="true"
      :class="['popup-wrapper', displayLayout]"
      closeable
      @closed="close"
      get-container=".games-detail-page"
      :style="{ background: bgColor }"
    >
      <p class="award_title">
        {{ $t('luckyDraw.award_desc.winning_award') }}
      </p>
      <!-- <p v-for="(item, index) in text" :key="index">{{ item }}</p> -->
      <p>{{ text }}</p>
      <button @click="goCheckPrize" :style="{ background: btnColor }">
        {{ $t('luckyDraw.award_desc.review') }}
      </button>
      <p class="footnote">{{ $t('luckyDraw.award_desc.prize_tip') }}</p>
    </van-popup>
  </section>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import {
    trackShowPrizePopup,
    trackClickCheckPrize,
  } from '@/pages/Activity/firebase'

  export default {
    props: {
      page: String,
      activityId: [String, Number],
      text: [String, Array],
      showResult: {
        type: Boolean,
        default: false,
      },
      inPopup: {
        type: Boolean,
        default: false,
      },
      bgColor: String,
      btnColor: String,
    },
    data() {
      return {
        showPopup: this.showResult,
        desc: [],
      }
    },
    computed: {
      ...mapState(['gameName']),
      ...mapGetters(['displayLayout']),
    },
    watch: {
      showResult(value) {
        this.showPopup = value
        if (value) {
          trackShowPrizePopup(this.page)
        }
      },
    },
    methods: {
      close() {
        this.showPopup = false
        this.$emit('closePopup')
      },
      goCheckPrize() {
        trackClickCheckPrize(this.page)
        // 跳转至我的奖品页
        const { query } = this.$route
        this.$router_push({
          path: `/prize-record`,
          query: {
            ...query,
            from: this.gameName || 'luckyDraw',
            activityId: this.activityId,
          },
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .popup-wrapper.van-popup {
    padding: 60px 72px;
    border-radius: 12px;
    max-height: 1400px;
    width: 70vw;
    font-size: 36px;
    line-height: 48px;
    background-color: #6c3cf8;
    text-align: center;
    color: #fff;
    font-family: 'Noto Sans';
    font-weight: 400;

    p:not(last-child) {
      font-size: 50px;
      line-height: 64px;
      font-weight: 600;
    }
    p.award_title {
      color: rgba(254, 237, 0, 0.9);
      font-size: 36px;
      line-height: 48px;
      margin-bottom: 20px;
    }
    button {
      width: 367px;
      height: 97px;
      background-color: #feed00;
      border-radius: 104px;
      margin: 50px auto;
      margin-top: 60px;
      color: #6c3cf8;
      font-size: 48px;
      line-height: 64px;
    }
    .footnote {
      text-align: center;
      font-size: 36px;
      line-height: 48px;
    }
    &.desktop-layout {
      width: 290px;
      max-height: 537px;
      padding: 23px 27.5px;
      border-radius: 4.6px;
      font-size: 13.8px;
      line-height: 18.4px;

      p:not(last-child) {
        font-size: 19px;
        line-height: 24.5px;
        font-weight: 600;
      }
      p.award_title {
        color: rgba(254, 237, 0, 0.9);
        font-size: 13.8px;
        line-height: 18.4px;
        margin-bottom: 7.7px;
      }
      button {
        width: 142px;
        height: 38px;
        background-color: #feed00;
        border-radius: 40px;
        margin: 19px auto;
        margin-top: 24px;
        font-size: 18.4px;
        line-height: 38px;
        cursor: pointer;
      }
      .footnote {
        text-align: center;
        font-size: 13.8px;
        line-height: 18.4px;
      }
    }
  }
</style>
